import React from 'react'
import Ctalogo1 from '../../../assets/images/OLD.png';

const reasons = [
  {
    title: 'Zero Travel Needed',
    desc: 'Your matters are handled entirely from abroad—with boots on the ground in India'
  },
  {
    title: 'One-Stop Convenience',
    desc: 'Legal, property, documentation, and compliance—all under one roof'
  },
  {
    title: 'Global Support. Indian Execution',
    desc: 'Round-the-clock communication in your time zone + local legal experts on the ground.'
  },
  {
    title: 'Native-Language Comfort',
    desc: 'We speak your language—literally and culturally'
  },
  {
    title: 'Visual Proof & Real-Time Updates',
    desc: 'Stay informed with photo/video updates and milestone tracking'
  },
  {
    title: 'Dedicated Relationship Manager',
    desc: 'No ticketing systems—just a real human who knows your case inside-out'
  },
  {
    title: 'Risk Protection & Peace of Mind',
    desc: 'Avoid scams, frauds, and costly errors with our compliant, ethical processes'
  },
];

const Portfolio = () => {
  return (
    <section className="py-5" >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-5 col-md-7 col-12 mb-4 mb-lg-0" style={{ textAlign: 'left' }}>
            <h1 style={{ fontWeight: 600, fontSize: '2rem', marginBottom: 1,  }}>
              Why NRIs Trust The NRI Advisors
            </h1>
            <p style={{ fontSize: 15, color: '#444', marginBottom: 10 }}>
              We’re not just another legal service. We’re your reliable, all-in-one ally in India.
            </p>
            <p style={{ fontSize: 15, color: '#444', marginBottom: 18 }}>
              Here’s why our clients choose us again and again:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginBottom: 18 }}>
              {reasons.map((item, idx) => (
                <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 13, fontSize: 17, lineHeight: 1.6 }}>
                  <span style={{ color: '#888', fontWeight: 700, fontSize: 15, marginRight: 12, marginTop: 2 }}>&#10003;</span>
                  <div>
                    <span style={{ fontWeight: 600, color: '#222' , fontSize: 15}}>{item.title}:</span>
                    <span style={{ color: '#444', marginLeft: 4, fontSize: 15 }}>{item.desc}</span>
                  </div>
                </li>
              ))}
            </ul>
            <p style={{ fontSize: 15, color: '#444', marginTop: 24 }}>
              We don’t just handle your case – we protect your legacy.
            </p>
          </div>
          <div className="col-lg-5 col-md-5 col-12 d-flex justify-content-center">
            <img
              src={Ctalogo1}
              alt="NRIs Trust The NRI Advisors"
              style={{
                width: 550,
                height: 824,
                objectFit: 'cover',
                borderRadius: 8,
                marginLeft: 4,
               
                maxWidth: '100%',
                padding: "1rem",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
export default Portfolio;